import React, { memo } from 'react';
import { GlobalProviders, AppInitializer } from '@web/components';

import { theme, SIGN_OUT_ROUTE, firebaseUIConfig, firebaseConfig, TITLE, ACCOUNT_ROUTE } from 'config';
import { WebPage } from './WebPage';
import './faIcons';

export const App: React.FC = memo(() => (
	<GlobalProviders theme={theme} firebaseUIConfig={firebaseUIConfig} firebaseConfig={firebaseConfig}>
		<AppInitializer loaderText={TITLE} signOutRoute={SIGN_OUT_ROUTE} accountRoute={ACCOUNT_ROUTE}>
			<WebPage/>
		</AppInitializer>
	</GlobalProviders>
));
